import React from 'react';
import { FormattedMessage } from 'react-intl';

import Text from 'ui/Text';

const WhyFocus = () => {
  return (
    <div className="intro-banner why-cdr">
      <Text modifiers="question-title primary-blue">
        <FormattedMessage
          id="Questionnaire.CDR.SubMenuItem.1"
          defaultMessage="Why focus on organizational capacity?"
        />
      </Text>
      <Text type="explanation">
        <FormattedMessage
          id="Questionnaire.CDR.WhyFocus.Explanation.1"
          defaultMessage={`
            Achieving social impact takes more than setting clear goals, developing sound 
            theories of change, and choosing the right measurement indicators. Turning vision 
            into change on the ground also requires a strong capacity to implement programs; 
            ongoing learning and adaptation as work unfolds; and organizational and operational 
            structures, processes, and capabilities. 
          `}
        />
      </Text>
      <Text type="explanation">
        <FormattedMessage
          id="Questionnaire.CDR.WhyFocus.Explanation.2"
          defaultMessage={`
            Because many of the issues that civil society organizations tackle will not be 
            solved in the short term, effective, nimble organizations are needed to adaptively 
            address these issues over many years. Moreover, CSOs often operate in a context of 
            limited resources and are obliged to continually seek creative ways of making tangible 
            progress toward their goals and deliver on their missions. This requires sustained 
            organizational capacity building. By capacity building we mean
          `}
        />
        <span className="emphasis">
          <b>
            <FormattedMessage
              id="Questionnaire.CDR.WhyFocus.Explanation.2.1"
              defaultMessage={`
              “any activity or investment that promotes, sustains, and/or enables the ability 
              of an organization to produce desired outcomes.”
            `}
            />
          </b>
        </span>
      </Text>
      <Text type="explanation">
        <FormattedMessage
          id="Questionnaire.CDR.WhyFocus.Explanation.3"
          defaultMessage={`
            African CSO leaders and funders recognize the importance of capacity building as a
            pillar of creating sustainable change. Despite this recognition, many barriers 
            prevent both CSOs and their funders from embracing a holistic view of organizations. 
            Establishing a direct link between building capacity and increased social impact 
            requires perseverance. Often-times funders are reluctant to invest in capacity building 
            and CSO leaders are preoccupied with keeping overhead costs low and delivering 
            programs and services within tight deadlines. Developing and implementing new 
            programs takes precedence over investments in growing strong organizations.
          `}
        />
      </Text>
      <Text type="explanation">
        <FormattedMessage
          id="Questionnaire.CDR.WhyFocus.Explanation.4"
          defaultMessage={`
            EPIC-Africa sees capacity building not as separate and secondary to program 
            development, but as integral to programming and believes that it is a 
            strategic investment that drives program quality and implementation. Our goal 
            is to elevate organizational capacity and highlight its importance to achieve 
            program impact.  The indicators that we have chosen are embedded in a capacity 
            building framework in order to help organizations assess their capacity and to 
            identify and prioritize actions to make their organizations stronger.
          `}
        />
      </Text>      
    </div>
  );
};

export default WhyFocus;


// WEBPACK FOOTER //
// ./src/components/CDRSections/WhyFocus.js